import type { CSSProperties } from "react";

const Bone = ({ className = "", style }: { className?: string; style?: CSSProperties }) => (
  <div className={`bg-muted animate-pulse rounded-md ${className}`} style={style} />
);

const ProfileSkeleton = () => (
  <div className="min-h-[100dvh] bg-background pb-24">
    {/* Header skeleton */}
    <div
      className="sticky top-0 z-20 border-b border-border/30 bg-background px-4"
      style={{ paddingTop: "max(0.75rem, env(safe-area-inset-top))" }}
    >
      <div className="h-[90px] flex items-center justify-between">
        <Bone className="h-7 w-16" />
        <div className="flex items-center gap-2.5">
          <div className="text-right space-y-1">
            <Bone className="h-3 w-20 ml-auto" />
            <Bone className="h-2.5 w-28 ml-auto" />
          </div>
          <Bone className="h-9 w-9 rounded-full" />
        </div>
      </div>
    </div>

    {/* Content skeleton */}
    <div className="max-w-md mx-auto px-4 pt-4 pb-10 space-y-3">
      {/* Card: Dados do plano */}
      <div className="bg-card border border-border/40 rounded-md p-3">
        <div className="flex items-center gap-2 mb-3">
          <Bone className="h-3.5 w-3.5" />
          <Bone className="h-3 w-24" />
        </div>
        <div className="h-px bg-border/40 mb-2" />
        <div className="space-y-2.5">
          {[1, 2, 3, 4].map((i) => (
            <div key={i} className="flex justify-between items-center">
              <Bone className="h-3 w-28" />
              <Bone className="h-3 w-16" />
            </div>
          ))}
        </div>
      </div>

      {/* Card: Configurações do plano */}
      <div className="bg-card border border-border/40 rounded-md p-3">
        <div className="flex items-center gap-2 mb-3">
          <Bone className="h-3.5 w-3.5" />
          <Bone className="h-3 w-32" />
        </div>
        <div className="h-px bg-border/40 mb-2" />
        <div className="space-y-2.5">
          {[1, 2].map((i) => (
            <div key={i} className="flex justify-between items-center">
              <Bone className="h-3 w-32" />
              <Bone className="h-3 w-20" />
            </div>
          ))}
        </div>
      </div>

      {/* Card: Aparência */}
      <div className="bg-card border border-border/40 rounded-md p-3">
        <div className="flex items-center gap-2 mb-3">
          <Bone className="h-3.5 w-3.5" />
          <Bone className="h-3 w-20" />
        </div>
        <div className="h-px bg-border/40 mb-2" />
        <div className="space-y-2.5">
          {[1, 2].map((i) => (
            <div key={i} className="flex justify-between items-center">
              <Bone className="h-3 w-24" />
              <Bone className="h-6 w-20 rounded-full" />
            </div>
          ))}
        </div>
      </div>

      {/* Card: Conta */}
      <div className="bg-card border border-border/40 rounded-md p-3">
        <div className="flex items-center gap-2 mb-3">
          <Bone className="h-3.5 w-3.5" />
          <Bone className="h-3 w-14" />
        </div>
        <div className="h-px bg-border/40 mb-2" />
        <div className="space-y-2.5">
          {[1, 2, 3].map((i) => (
            <div key={i} className="flex justify-between items-center">
              <Bone className="h-3 w-28" />
              <Bone className="h-3 w-3" />
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
);

export default ProfileSkeleton;
